import React, { useState } from "react";
import { Modal } from "antd";
import PrimaryButton from "./PrimaryButton";
import axios from "axios";

const base_url = "https://verimedramja.pythonanywhere.com/verimed/";

export default function AppointmentForm() {
  const initialFormData = {
    department: "",
    doctor: "",
    full_name: "",
    email: "",
    country_code: "CM",
    phone: "",
    date: "",
    time: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const COUNTRY_CODES = [
    { code: "CM", dial: "+237", label: "🇨🇲 Cameroon" },
    { code: "IN", dial: "+91", label: "🇮🇳 India" },
    { code: "US", dial: "+1", label: "🇺🇸 USA" },
    { code: "UK", dial: "+44", label: "🇬🇧 UK" },
    { code: "AE", dial: "+971", label: "🇦🇪 UAE" },
    { code: "CA", dial: "+1", label: "🇨🇦 Canada" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const selectedCountry = COUNTRY_CODES.find(
        (c) => c.code === formData.country_code
      );

      const payload = {
        ...formData,
        phone: `${selectedCountry.dial}${formData.phone}`,
      };

      const response = await axios.post(`${base_url}contactus_c/`, payload);

      console.log("Appointment booked:", response.data);

      setIsSuccess(true);
      setModalMessage("Appointment booked successfully!");
      setModalVisible(true);
      setFormData(initialFormData);
    } catch (err) {
      console.error("Error booking appointment:", err);
      setIsSuccess(false);
      setModalMessage("Failed to book appointment. Please try again later.");
      setModalVisible(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="appointmentForm_wrapper">
      {/* Heading */}
      <h2 className="appointmentForm_heading">
        <span className="appointmentForm_blackText">
          Book appointment or call:
        </span>
        <br />
        North America{" "}
        <span className="appointmentForm_blueText">+1-551-502-0063</span>
        <br />
        Africa & Europe{" "}
        <span className="appointmentForm_blueText">+237-6-50-41-99-86</span>
      </h2>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="appointmentForm_form">
        {/* Department */}
        <select
          name="department"
          value={formData.department}
          onChange={handleChange}
          required
          className="appointmentForm_select"
        >
          <option value="">Select Services</option>
          <option>Comprehensive Physician Intake (In-Person)</option>
          <option>In-Home Follow-up Physician Visit</option>
          <option>Virtual Physician Visit</option>
          <option>Nurse Wellness Check</option>
          <option>Rehydration & IV Fluid Therapy</option>
          <option>Infusion Therapy (Prescribed Medication)</option>
          <option>Care Management & Navigation</option>
          <option>Wellness Coaching</option>
          <option>Diabetes Coaching & Chronic Illness Management</option>
          <option>Live-in Family Wellness Nurse</option>
        </select>

        {/* Doctor */}
        <select
          name="doctor"
          value={formData.doctor}
          onChange={handleChange}
          required
          className="appointmentForm_select"
        >
          <option value="">Select Doctor</option>
          <option>Dr Stanley-Ivo Foy</option>
          <option>Dr. Derek Ray</option>
          <option>Dr. Racheal O'Connell</option>
        </select>

        {/* Full Name */}
        <input
          type="text"
          name="full_name"
          value={formData.full_name}
          onChange={handleChange}
          placeholder="Full Name"
          required
          className="appointmentForm_input"
        />

        {/* Email */}
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email Address"
          required
          className="appointmentForm_input"
        />

        {/* Country code + phone */}
        <div className="appointmentForm_phoneRow">
          <select
            name="country_code"
            value={formData.country_code}
            onChange={handleChange}
            required
            className="appointmentForm_countrySelect"
          >
            {COUNTRY_CODES.map((c) => (
              <option key={c.code} value={c.code}>
                {c.label} {c.dial}
              </option>
            ))}
          </select>

          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Phone Number"
            required
            className="appointmentForm_phoneInput"
          />
        </div>

        {/* Date */}
        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          required
          className="appointmentForm_input"
        />

        {/* Time */}
        <input
          type="time"
          name="time"
          value={formData.time}
          onChange={handleChange}
          required
          className="appointmentForm_input"
        />

        {/* Button */}
        <div className="appointmentForm_buttonRow">
          <PrimaryButton
            label={loading ? "Booking..." : "Book an Appointment"}
            type="submit"
            disabled={loading}
          />
        </div>
      </form>

      {/* SUCCESS / ERROR MODAL */}
      <Modal
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        centered
        className="appointmentForm_modal"
      >
        <p
          className={
            isSuccess
              ? "appointmentForm_modalMessageSuccess"
              : "appointmentForm_modalMessageError"
          }
        >
          {modalMessage}
        </p>

        <PrimaryButton label="Close" onClick={() => setModalVisible(false)} />
      </Modal>
    </div>
  );
}
